import { createName } from 'store/utils';

import { FEATURE_NAME } from './consts';

const getName = createName(FEATURE_NAME);

export const SET_MAIN_ERROR = getName('SET_MAIN_ERROR');
export const SET_APP_ERROR = getName('SET_APP_ERROR');
export const RESET_ERRORS = getName('RESET_ERRORS');
